import ProjectCard from "./ProjectCard.jsx";
import useProjectModelManagementStore from "../store/useProjectManagementStore.js";

const ProjectManagementMainSection = ({ isLoading = false }) => {
  const { projects } = useProjectModelManagementStore();

  if (isLoading) {
    return (
      <div className="project-mgmt-state text-center py-5">
        <i className="fa fa-spinner fa-spin fa-3x mb-3 text-primary"></i>
        <p className="text-muted">Loading projects...</p>
      </div>
    );
  }

  if (!projects || projects.length === 0) {
    return (
      <div className="project-mgmt-state text-center py-5">
        <p className="text-muted">No data present</p>
      </div>
    );
  }

  // .lf-grid-auto (master responsive layer) auto-fits as many ~320px columns as
  // fit. The old col-sm-4 was a hard 3 columns from 576px up, which crushed a
  // card to ~170px on a tablet and never went past 3 on an ultrawide.
  return (
    <div className="project-mgmt-grid lf-grid-auto">
      {projects.map((project) => (
        <ProjectCard key={project._id || project.id} project={project} />
      ))}
    </div>
  );
};

export default ProjectManagementMainSection;
